<template>
	<div>
		<el-form :inline="true">
			<el-form-item>
				<el-button type="primary" @click="dialogVisible = true">新增</el-button>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				border
				stripe>
			<el-table-column
					prop="roleName"
					label="订阅计划"
					width="150">
			</el-table-column>
			<el-table-column
					prop="memberLimitNum"
					label="用户限制数量"
					width="110">
			</el-table-column>
			<el-table-column
					prop="projectLimitNum"
					label="项目限制数量"
					width="110">
			</el-table-column>
			<el-table-column
					prop="personaLimitNum"
					label="人物角色限制数量"
					width="140">
			</el-table-column>
			<el-table-column
					prop="journeyLimitNum"
					label="旅程地图限制数量"
					width="140">
			</el-table-column>
			<el-table-column
					prop="experLimitNum"
					label="体验调查限制数量"
					width="140">
			</el-table-column>
			<el-table-column
					prop="retrieveLimitNum"
					label="问卷回收限制数量"
					width="140">
			</el-table-column>
			<el-table-column
					prop="icon"
					label="操作">

				<template slot-scope="scope">
					<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
				</template>
			</el-table-column>

		</el-table>

		<!--新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="dialogVisible"
				width="500px"
				:before-close="handleClose">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" >
				<el-form-item label="订阅计划" prop="roleName" label-width="140px">
					<el-input v-model="editForm.roleName" style="width: 300px" placeholder="请输入订阅计划名称"></el-input>
				</el-form-item>
				<el-form-item label="用户限制数量"  prop="memberLimitNum" label-width="140px">
					<el-input v-model="editForm.memberLimitNum" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="项目限制数量"  prop="projectLimitNum" label-width="140px">
					<el-input v-model="editForm.projectLimitNum" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="人物角色限制数量"  prop="personaLimitNum" label-width="140px">
					<el-input v-model="editForm.personaLimitNum" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="旅程地图限制数量"  prop="journeyLimitNum" label-width="140px">
					<el-input v-model="editForm.journeyLimitNum" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="体验调查限制数量"  prop="experLimitNum" label-width="140px">
					<el-input v-model="editForm.experLimitNum" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="问卷回收限制数量"  prop="retrieveLimitNum" label-width="140px">
					<el-input v-model="editForm.retrieveLimitNum" style="width: 300px"></el-input>
				</el-form-item>


			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import JSON_BIG from 'json-bigint'
	export default {
		name: "Subscribe",
		data() {
			return {
				searchForm: {},
				total: 0,
				size: 10,
				current: 1,
				dialogVisible: false,
				editForm: {},
				tableData: [],
				editFormRules: {
					roleName: [
						{required: true, message: '请输入订阅计划名称', trigger: 'blur'}
					],
					memberLimitNum: [
						{required: true, message: '请输入用户限制数量', trigger: 'blur'}
					],
					projectLimitNum: [
						{required: true, message: '请输入项目限制数量', trigger: 'blur'}
					],
					personaLimitNum: [
						{required: true, message: '请输入人物角色限制数量', trigger: 'blur'}
					],
					journeyLimitNum: [
						{required: true, message: '请输入旅程地图限制数量', trigger: 'blur'}
					],
					experLimitNum: [
						{required: true, message: '请输入体验调查限制数量', trigger: 'blur'}
					],
					retrieveLimitNum: [
						{required: true, message: '请输入问卷回收限制数量', trigger: 'blur'}
					]
				},
			}
		},
		created() {
			this.getSubscribeList();
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getSubscribeList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getSubscribeList()
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},

			getSubscribeList() {
				this.$axios.get("/uxm/config/list", {}).then(res => {
					this.tableData = res.data.data
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// 确保数字字段为数字类型
						const submitData = {
							...this.editForm,
							memberLimitNum: this.editForm.memberLimitNum ? parseInt(this.editForm.memberLimitNum) : null,
							projectLimitNum: this.editForm.projectLimitNum ? parseInt(this.editForm.projectLimitNum) : null,
							personaLimitNum: this.editForm.personaLimitNum ? parseInt(this.editForm.personaLimitNum) : null,
							journeyLimitNum: this.editForm.journeyLimitNum ? parseInt(this.editForm.journeyLimitNum) : null,
							experLimitNum: this.editForm.experLimitNum ? parseInt(this.editForm.experLimitNum) : null,
							retrieveLimitNum: this.editForm.retrieveLimitNum ? parseInt(this.editForm.retrieveLimitNum) : null
						}
						this.$axios.post('/uxm/config/' + (this.editForm.id?'update' : 'save'), submitData)
							.then(res => {
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success'
								});
								this.getSubscribeList()
								this.dialogVisible = false
								this.resetForm('editForm')
							})
					} else {
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/uxm/config/info/' + id).then(res => {
					this.editForm = res.data.data
					console.log("e", this.editForm)
					this.dialogVisible = true
				})
			},
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}

</style>
